// Phase 7 D4 — Track D T-D6. Payment review-queue count.
//
// Lightweight read used by the toolbar to badge the "Review" affordance.
// Phase 7 D5 — refactored to use the typed
// `apiClient.payments.reviewQueue.list()` surface that lands alongside
// the /payments/review route. The hook stays retry-0 / staleTime 60s so
// a transient failure silently degrades the badge rather than spamming
// the network.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '../app/apiClient.js';

export const PAYMENT_REVIEW_COUNT_QUERY_KEY = ['payments', 'review-count'] as const;

export function usePaymentReviewCount(): UseQueryResult<number, Error> {
  return useQuery<number, Error>({
    queryKey: [...PAYMENT_REVIEW_COUNT_QUERY_KEY],
    queryFn: async () => {
      const items = await apiClient.payments.reviewQueue.list();
      return items.length;
    },
    // Don't retry — a transient failure should silently degrade the badge
    // rather than spamming the network.
    retry: 0,
    staleTime: 60_000,
  });
}
